import common from './common'
import user from './user'

export default {
  common,
  user,
}
